import { useAuthStore } from './authStore'
import { setTimezoneSources } from '@/utils/timezone'

/**
 * Keeps the display timezone in step with the signed-in user. Every login,
 * tenant switch, /auth/me refresh and settings edit writes `user` into the auth
 * store, so one subscription covers them all without touching those call sites.
 * Import this module once at app start (main.tsx).
 */
function sync(user: { timezone?: string | null; tenantTimezone?: string | null } | null): void {
  setTimezoneSources({ user: user?.timezone, tenant: user?.tenantTimezone })
}

sync(useAuthStore.getState().user)
useAuthStore.subscribe(state => sync(state.user))
